/**
 * Intent Cards module
 *
 * Loads intent cards from the cards API and caches in cardsState. Rendering lives
 * in dialog-shell.js `renderPlays(cards)` — the A+B->C workspace groups them by
 * pipeline metadata (the old create-ui/intent-cards grid was removed 2026-06-24).
 *
 * Usage from app init:
 *   import { initIntentCards } from './modules/create/cards/intent-cards.js'
 *   const cards = await initIntentCards()
 *   renderPlays(cards)  // from dialog/dialog-shell.js
 */

import { fetchIntentCards as fetchFromAPI } from './api.js'
import { cardsState } from './state.js'
import { createLogger } from '../../../utils/logger.js'
const log = createLogger('create.cards.intent-cards')


/**
 * Initialize intent cards: load from API, cache in cardsState.
 * Safe to call multiple times — skips fetch if already loaded.
 *
 * @returns {Promise<Card[]>} loaded cards (empty array on failure)
 */
export async function initIntentCards() {
  if (cardsState.intent.loaded && cardsState.intent.cards.length > 0) {
    return cardsState.intent.cards
  }

  cardsState.intent.loading = true

  try {
    const cards = await fetchFromAPI()
    cardsState.intent.cards = cards
    cardsState.intent.loaded = true
    return cards
  } catch (err) {
    log.warn('[intent-cards] API failed:', err.message)
    cardsState.intent.cards = []
    cardsState.intent.loaded = true
    return []
  } finally {
    cardsState.intent.loading = false
  }
}
